<template>
  <div class='ClientsList' :class="{ gray: isPar(chave) }">
    <div class="c-nome">
      {{ data.usuario.nome }}
    </div>
    <div style="width: 12%" class="mobile-none">
      {{ data.usuario.usuario }}
    </div>
    <div class="c-email">
      {{ data.usuario.email }}
    </div>
    <div style="width: 10%" class="mobile-none">
      {{ data.endereco.cidade }} - {{ data.endereco.numero }}, {{ data.endereco.uf }}
    </div>
    <div style="width: 10%" class="mobile-none">
      {{ data.pedidos.length }}
    </div>
    <div style="width: 10%" class="mobile-none">
      {{ data.valorTotalPedidos }}
    </div>
    <div class="c-pedido">
      #{{ !data.pedidos.length ? 'sem pedidos' : data.pedidos[data.pedidos.length - 1].id }}
    </div>
    <div class="acoes">
      <eyes-icon
      @click="view"
      text="Visualizar"
      :active="true"
      :optionsLabel="{ marginTop: '50px' }"
      :options="{ width: '20px', height: '20px', action: true }"/>
      <edit-icon
      @click="edit"
      text="Editar cliente"
      :active="true"
      :optionsLabel="{ marginTop: '80px', marginRight: '20px' }"
      :options="{ width: '22px', height: '22px' }"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EditIcon from '../../Icons/EditIcon'
import EyesIcon from '../../Icons/EyesIcon'
export default {
  name: 'ClientsList',
  components: { EditIcon, EyesIcon },
  props: ['data', 'chave'],
  data () {
    return {
      checked: false
    }
  },
  computed: {
  },
  methods: {
    ...mapActions(['SetClientEdit', 'SetClientView']),
    edit () {
      this.SetClientEdit(this.data)
         .then(() => {
           this.$router.push('/painel/client/edit')
         })
    },
    view () {
      this.SetClientView(this.data)
        .then(() => {
          this.$router.push('/painel/client/view')
        })
    },
    isPar (n) {
      let d = n / 2
      return d % 1 === 0
    }
  }
}
</script>

<style scoped>
.ClientsList {
  height: 6%;
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  padding: 1%;
}

.acoes {
  width: 6%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gray {
  background-color: #F5F5F5F5;
}

.c-nome {
  width: 12%;
}

.c-email {
  width: 26%;
}

.c-pedido {
  width: 14%;
}

@media (max-width: 500px) {
  .mobile-none {
    display: none;
  }
  .c-nome {
    width: 20%;
  }
  .c-email {
    width: 40%;
  }
  .c-pedido {
    width: 20%;
  }
  .acoes {
    width: 20%;
  }
}
</style>
